<template>
  <v-dialog :value="active" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('Contact.Form.header')}}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="contactForm" v-model="isValid">
          <v-row>
            <v-col cols="12">
              <v-select 
                v-if="availableContacts.length"
                v-model="type" 
                :label="$t('Contact.Form.contact')" 
                :items="availableContacts" 
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field 
                v-model="subject" 
                :label="$t('Contact.Form.subject')" 
                :error-messages="subjectErrors"
                :hint="$t('Contact.Form.subjectHint')"
                required
              />
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="content"
                :label="$t('Contact.Form.contents')" 
                :error-messages="contentErrors"
                required
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close">{{$t('Global.Action.close')}}</v-btn>
        <v-btn color="primary darken-1" text @click="send" :loading="sending">{{$t('Global.Action.send')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { ContactService } from '@portal/api'
export default {
  name: "TheContactModal",
  mixins: [validationMixin],
  data: () => ({
    type: null,
    subject: '',
    content: '',
    sending: false,
    isValid: false
  }),
  validations: {
    subject: { required },
    content: { required }
  },
  computed: {
    ...mapState('contact', [
      'active'
    ]),
    ...mapState('auth', [
      'user'
    ]),
    availableContacts () {
      return [
        { text: this.$t('Contact.commercial'), value: 'commercial', disabled: !this.user.contactCommercial }, 
        { text: this.$t('Contact.operational'), value: 'operational', disabled: !this.user.contactOperational },
        { text: this.$t('Contact.accounting'), value: 'accounting', disabled: !this.user.contactAccounting }
      ].filter(contact => !contact.disabled)
    },
    subjectErrors () {
      const errors = []
      if (!this.$v.subject.$dirty) return errors
      !this.$v.subject.required && errors.push(this.$t('Contact.Form.subjectRequired'))
      return errors
    },
    contentErrors () {
      const errors = []
      if (!this.$v.content.$dirty) return errors
      !this.$v.content.required && errors.push(this.$t('Contact.Form.contentsRequired'))
      return errors
    }
  },
  methods: {
    ...mapMutations('contact', [
      'showModal',
      'closeModal'
    ]),
    close () {
      this.subject = ''
      this.content = ''
      this.$v.$reset()
      this.closeModal()
    },
    async send () {
      this.$v.$touch()
      if (!this.$v.$invalid && !this.sending) {
        this.sending = true
        try {
          await ContactService.sendMsg(this.subject, this.content, this.type)
          this.$store.dispatch('notifier/success', this.$t('Contact.Message.success'))
        } catch (error) {
          this.$store.dispatch('notifier/error', this.$t('Contact.Message.failed'))
          this.sending = false
        }
        
        this.sending = false
        this.close()
      }
    }
  },
  created () {
    this.type = this.availableContacts[0] || null
  }
}
</script>
